'use strict';

import React, { Component } from 'react';
import Table from './Table.jsx';
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import { LogHelper } from 'com-gyf-webcore-loghelper';

class DistribucionLimitesCuenta extends Component {
    constructor(props) {
        super(props);

        this.state = {
            limiteCompra: props.data.limiteCompra,
            selectLimit: props.data.selectLimit,
            selectAdm: props.data.selectAdm,
            pasoPorEmpresa: props.data.pasoPorEmpresa,
            pasoPorCuenta: props.data.pasoPorCuenta,
            pasoPorTarjeta: props.data.pasoPorTarjeta,
            administradoras: props.data.administradoras,
            empresas: props.data.empresas.slice(),
            cuentas: props.data.cuentas.slice(),
            tarjetas: props.data.tarjetas.slice(),
            novedadesEmpresas: props.data.novedadesEmpresas,
            novedadesCuentas: props.data.novedadesCuentas,
            novedadesTarjetas: props.data.novedadesTarjetas,
            empresasOriginal: props.data.novedadesEmpresasOriginal,
            cuentasOriginal: props.data.novedadesCuentasOriginal,
            tarjetaOriginal: props.data.novedadTarjetaOriginal,
            empresasNoModificadas: props.data.empresasNoModificadas,
            cuentasNoModificadas: props.data.cuentasNoModificadas,
            tarjetasNoModificadas: props.data.tarjetasNoModificadas,
            datosCliente: props.data.datosCliente,
            functions: props.data.functions,
            limiteCliente: props.data.limiteCliente,
            administradoraSeleccionadaId: props.data.administradoraSeleccionadaId,
            seEstaEditando: props.data.seEstaEditando,
            selectCuentasId: props.data.selectCuentasId,
            selectEnterpriseId: props.data.selectEnterpriseId,
            limiteCuentaExcedido: props.data.limiteCuentaExcedido,
            //Propiedades de Cuentas...
            valorInicialEdicion: undefined,
            valorInicialEdicionId: undefined,
            valorAnteriorNovedad: undefined,
            editandoLimiteCuenta: false,
            pressEdit: false,
            seEstaEditando: false,
            selectedId: undefined,
            editadoId: undefined,
            editId: undefined,
            estadoMostrarMensajeLimitesIguales: false
        }
    }

    /**
    * Hace aparecer el lapiz en distribucion de limites CUENTAS.
    * @param {any} id
    */
    aparicionLapizEdicion(id) {
        this.setState({
            selectedId: (this.state.pressEdit != true ? id : this.state.selectedId)
        });
    }

    /**
    * Hace desaparecer el lapiz en distribucion de limites CUENTAS.
    */
    desaparicionLapizEdicion() {
        this.setState({
            selectedId: (this.state.pressEdit !== true ? undefined : this.state.selectedId)
        });
    }

    /**
     * Es la accion de darlo click al boton del lapiz.
     * @param {any} id
     * @param {any} limiteInicial
     * @param {any} valorAnterior
     */
    comienzoDeEdicion(id, limiteInicial, valorAnterior) {
        let limiteInicialInt = parseInt(limiteInicial);     
        
        let estado = {
            cuentas: this.state.cuentas,
            novedadesCuentas: this.state.novedadesCuentas,
            seEstaEditando: this.state.seEstaEditando,
            limiteCuentaExcedido: this.state.limiteCuentaExcedido
        }

        this.props.obtenerLimiteCuentaPorProducto(estado, id);
        
        this.setState({ limiteCompra: this.props.data.limiteCompra });

        this.setState({
            valorInicialEdicion: limiteInicial,
            valorInicialEdicionId: limiteInicial,
            valorAnteriorNovedad: valorAnterior,
            pressEdit: true,
            editId: id,
            seEstaEditando: true,
            limiteCompra: this.props.data.limiteCompra
        }, () => {
            this.actualizarEstadoPadre();
        });
    }

    /**
    * Se realiza el cambio del limite de la cuenta seleccionada.
    * @param {any} valor
    */
    modificacionLimite(valor) {
        valor = valor.toString() == 'NaN' ? 0 : valor;
        /*si x.Valor == valor quiere decir que no es uina novedad pero si el id es igual al valor entonces si*/
        let limiteCompraId = this.state.limiteCompra.find(x => x.Valor == valor || x.Id == valor).Id;

        if (valor >= 0 && valor <= 999999999) {
            let cuentas = this.state.cuentas;
            for (var i = 0; i < cuentas.length; i++) {
                if (cuentas[i].Id == this.state.selectedId) {
                    cuentas[i].Valor = valor; cuentas[i].Editado = true; cuentas[i].LimiteCompraId = limiteCompraId;
                }
            }
            this.setState({
                cuentas: cuentas,
            }, () => {
                this.actualizarEstadoPadre();
            });
        }
    }

    /**
    * Se realiza el cambio de la novedad de la cuenta seleccionada.
    * @param {any} valor
    * @param {any} idNovedad
    */
    modificacionNovedad(valor, idNovedad, idRow) {
        valor = valor.toString() == 'NaN' ? 0 : valor;

        if (valor >= 0 && valor <= 999999999) {
            let cuentas = this.state.cuentas;
            let cuentaSeleccionadaIndex = this.state.cuentas.findIndex(x => x.Id == idRow);
            let novedadesCuentas = this.state.novedadesCuentas;
            for (var i = 0; i < novedadesCuentas.length; i++) {
                if (novedadesCuentas[i].Id == idNovedad) {
                    //novedadesCuentas[i].ValorAnterior =
                    novedadesCuentas[i].ValorNovedad;
                    novedadesCuentas[i].ValorNovedad = valor;
                    cuentas[cuentaSeleccionadaIndex].Editado = true;
                }
            }
            this.setState({
                novedadesCuentas: novedadesCuentas,
                cuentas: cuentas
            }, () => {
                this.actualizarEstadoPadre();
            });
        }
    }

    /**
    * Se acepta la edicion del limite/novedad.
    */
    aceptarEdicion() {

        this.setState({
            editId: undefined,
            editadoId: undefined,
            selectedId: undefined,
            valorInicialEdicion: undefined,
            valorInicialEdicionId: undefined,
            valorAnteriorNovedad: undefined,
            pressEdit: false,
            seEstaEditando: false,
            estadoMostrarMensajeLimitesIguales: false
        }, () => {
            this.actualizarEstadoPadre();
        });
    }

    /**
    * Se muestra el mensaje de limites iguales
    */
    mostrarMensajeLimitesIguales() {
        this.setState({ estadoMostrarMensajeLimitesIguales: true });
    }

    /**
    * Cancela la edicion de limite de la cuenta seleccionada.
    * @param {any} id
    */
    cancelEdicionLimite(id) {
        let cuentas = this.state.cuentas;
        let cuentaSeleccionadaIndex = this.state.cuentas.findIndex(x => x.Id == id);
        let limiteAnterior = this.state.valorInicialEdicion
        let limiteAnteriorId = this.state.valorInicialEdicionId;
        for (var i = 0; i < cuentas.length; i++) {
            if (cuentas[i].Id == this.state.selectedId) {
                cuentas[i].Valor = limiteAnterior;
                cuentas[i].Editado = false;
                cuentas[cuentaSeleccionadaIndex].Editado = false;
                cuentas[i].LimiteCompraId = limiteAnteriorId;
            }
        }

        this.setState({
            editId: undefined,
            cuentas: cuentas,
            editadoId: undefined,
            selectedId: undefined,
            valorInicialEdicion: undefined,
            valorInicialEdicionId: undefined,
            valorAnteriorNovedad: undefined,
            pressEdit: false,
            seEstaEditando: false,
            estadoMostrarMensajeLimitesIguales: false
        }, () => {
            this.actualizarEstadoPadre();
        });
    }

    /**
    * Cancela la edicion de limite de la novedad seleccionada.
    * @param {any} id
    * @param {any} idRow
    */
    cancelEdicionNovedad(id, idRow) {
        let limiteAnterior = this.state.valorInicialEdicion
        let novedadesCuentas = this.state.novedadesCuentas;
        let valorAnterior = this.state.valorAnteriorNovedad;

        for (var i = 0; i < novedadesCuentas.length; i++) {
            if (novedadesCuentas[i].Id == id) {
                novedadesCuentas[i].ValorNovedad = limiteAnterior; novedadesCuentas[i].ValorAnterior = valorAnterior; novedadesCuentas[i].Editado = false;
            }
        }

        this.setState({
            editId: undefined,
            novedadesCuentas: novedadesCuentas,
            editadoId: undefined,
            selectedId: undefined,
            valorInicialEdicion: undefined,
            valorAnteriorNovedad: undefined,
            pressEdit: false,
            seEstaEditando: false
        }, () => {
            this.actualizarEstadoPadre();
        });
    }

    componentDidMount() {
        this.actualizarEstadoPadre();
    }

    /**
    * Muestra la leyenda de la ultima edición de la novedad seleccionada.
    * @param {any} id
    */
    muestraEditadoNovedad(id) {
        this.setState({ editadoId: id });
    }

    /**
    * Oculta la leyenda de la ultima edición de la novedad seleccionada.
    */
    ocultaEditadoNovedad() {
        this.setState({ editadoId: undefined });
    }

    /**
    * Actualiza los datos del estado del componente padre.
    */
    actualizarEstadoPadre() {
        let estado = {
            cuentas: this.state.cuentas,
            novedadesCuentas: this.state.novedadesCuentas,
            seEstaEditando: this.state.seEstaEditando,
            limiteCuentaExcedido: this.state.limiteCuentaExcedido
        }
        
        this.props.cambiarEstadoEdicion(estado);
    }

    /**
    * Selecciono la empresa.
    * @param {any} id
    */
    seleccionDeEmpresa(id) {
        this.setState({
            selectEnterpriseId: id
        });
    }

    /**
     * 
     */
    aceptModalCuentas() {
        $('#okModalCuentas').modal('toggle');
    }

    render() {
        //Seteo el estado global...
        let data = this.state;

        //Reemplazo el state por el props de limiteCompra, ya que lo obtiene del padre (DistribucionLimites)
        data.limiteCompra = this.props.data.limiteCompra;

        if (data != undefined) {
            return (
                <div className="container-fluid bottom-separator-xxs">
                    <Table
                        limitesCliente={this.props.limitesCliente}
                        data={data}
                        updateLimitsFunction={this.props.updateLimitsFunction}
                        functions={this.props.functions}
                        internalData={this.props.internalData}
                        editNotifyFn={this.props.editNotifyFn}
                        simulationEditLimitOn={this.props.simulationEditLimitOn}
                        aparicionLapizEdicion={(id) => this.aparicionLapizEdicion(id)}
                        comienzoDeEdicion={(id, valorInicial, valorAnterior) => this.comienzoDeEdicion(id, valorInicial, valorAnterior)}
                        desaparicionLapizEdicion={() => this.desaparicionLapizEdicion()}
                        cancelEdicionLimite={(id) => this.cancelEdicionLimite(id)}
                        cancelEdicionNovedad={(id, idRow) => this.cancelEdicionNovedad(id, idRow)}
                        aceptarEdicion={() => this.aceptarEdicion()}
                        mostrarMensajeLimitesIguales={() => this.mostrarMensajeLimitesIguales()}
                        modificacionLimite={(valor) => this.modificacionLimite(valor)}
                        modificacionNovedad={(valor, id, idRow) => this.modificacionNovedad(valor, id, idRow)}
                        muestraEditadoNovedad={(id) => this.muestraEditadoNovedad(id)}
                        ocultaEditadoNovedad={() => this.ocultaEditadoNovedad()}
                        seleccionDeEmpresa={(id) => this.seleccionDeEmpresa(id)} />
                    <GenericModal type={"OK_OTHER"} id={"okModalCuentas"} className="modal fade-out" onClick={this.aceptModalCuentas} header={"Advertencia"}
                        body={"Se deben confirmar o descartar los cambios de límite que se iniciaron en la grilla"} />
                </div>
            );
        }
        else {
            return null;
        }
    }

}

export default DistribucionLimitesCuenta;